import { render, staticRenderFns } from "./months_header_item.vue?vue&type=template&id=b0b04828&"
import script from "./months_header_item.vue?vue&type=script&lang=js&"
export * from "./months_header_item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports